<template>
  <div class="bg-sub">
    <div class="header-page">
      <h4 class="text-center header-contact">ติดต่อเรา</h4>
      <div class="area-map">
        <iframe class="googlemap" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3872.619175207168!2d100.61843031499706!3d13.921696597084093!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31194d36acba2de7%3A0x10cdbf1d9b0841c8!2sRoyal+Thai+Air+Force!5e0!3m2!1sen!2sth!4v1549009956163" width="100%" height="400"
          frameborder="0" style="border:0" allowfullscreen></iframe>
      </div>

      <div class="bg">
        <mdb-card class="card-contactus">
          <mdb-card-body>
            <div class="card-contact">
              <div class="text-center con-detail">
                <h5>กรมสื่อสารอิเล็กทรอนิกส์ทหารอากาศ</h5>
                <p>ROYAL THAI AIR FORCE</p>
              </div>
              <p class="text-contactus">
                <fa class="icon-con" icon="map-marker" /><span class="text-con">171 แขวงสีกัน เขตดอนเมือง กทม 10210</span></p>
              <p class="text-contactus">
                <fa class="icon-con" icon="phone" /><span class="text-con">02-534-8019</span></p>
              <!-- <p class="text-contactus"> -->
                <!-- <fa class="icon-con" icon="print" /><span class="text-con">+66 2949 4250</span></p> -->
              <p class="text-contactus">
                <fa class="icon-con" icon="envelope" /><span class="text-con">iptvrtaf@gmail.com</span></p>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>
    </div>
  </div>

</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
import {
  mdbRow,
  mdbCol,
  Btn,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbBtn,
  Fa
} from 'mdbvue';

export default {
  name: 'ContactUsPage',
  components: {
    mdbRow,
    mdbCol,
    Btn,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbBtn,
    Fa
  },
  mounted() {
    localStorage.pincode = '';
    this.Session();
  },
  methods: {
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
  }
};
</script>

<style>
.card-contactus {
  position: absolute;
  top: 35%;
  left: 26%;
  width: 50%;
  margin: 0 auto;
  padding: 50px 0;
}

.bg {
  /*background-position: center;*/
  /*background-size: cover;*/
  height: 400px;
  /*background-image: url("../../src/assets/img/bg-con.jpg");*/
}
</style>
